<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M27.334 16c0 6.259-5.074 11.333-11.334 11.333-6.259 0-11.333-5.074-11.333-11.334C4.667 9.74 9.741 4.666 16 4.666c6.26 0 11.334 5.074 11.334 11.333zm2 0c0 7.363-5.97 13.333-13.334 13.333-7.363 0-13.333-5.97-13.333-13.334C2.667 8.636 8.637 2.666 16 2.666c7.364 0 13.334 5.97 13.334 13.333zM15 10.332a1 1 0 112 0v8.919l2.627-2.626a1 1 0 011.414 1.414l-4.334 4.333a1 1 0 01-1.414 0L10.96 18.04a1 1 0 011.414-1.414L15 19.252v-8.92z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'arrowsCircleArrowDownFilled'
}
</script>
